var ElementsType = /** @class */ (function () {
    function ElementsType() {
    }
    /**
     *
     */
    ElementsType.TRIANGLE = 'triangle';
    /**
     *
     */
    ElementsType.LINE = 'line';
    return ElementsType;
}());
export { ElementsType };
